import { UnitStateV2 } from '@eppendorf/vnls-device-service-utils';
import { HasChildren } from '@eppendorf/vnls-react-components';

interface UnlessOfflineV2Props extends HasChildren {
  unitState?: UnitStateV2;
  noFallback?: boolean;
}

export function UnlessOfflineV2({
  unitState,
  children,
  noFallback = false,
}: UnlessOfflineV2Props) {
  if (unitState === UnitStateV2.Offline.toString()) {
    return <div>{noFallback ? '' : '-'}</div>;
  }

  return children;
}
